import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { useParams, useSearchParams } from 'next/navigation';
import React from 'react';

import NoData from '@/components/NoData';
import Pagination from '@/components/pagination';

import { KeyTabCollection } from '..';
import ActivityCell from './ActivityCell';
import { ACTIVITY_COLUMNS, ACTIVITY_COLUMNS_ID } from './constants';
import ActivityFilter from './Filter';
import { getColumnClassNameActivity } from './helpers';
import useActivity, { PAGE_SIZE } from './useActivity';

const CollectionActivity: React.FC = () => {
  const params = useParams();
  const collectionId = params.id;
  const { list, totalPage, loading } = useActivity((collectionId as string) ?? null);
  const searchParam = useSearchParams();
  const page = searchParam.get('page') ?? 1;

  return (
    <div className="mt-4">
      <ActivityFilter />
      <Table
        aria-label="Activity table"
        removeWrapper
        isHeaderSticky
        classNames={{
          thead: 'border-none',
          tr: '!shadow-none',
          th: 'sm:text-[13px]',
          td: 'lg:text-[13px] sm:text-[12px]',
          base: 'xl:overflow-x-auto xl:scrollbar-custom',
        }}
      >
        <TableHeader columns={ACTIVITY_COLUMNS}>
          {(column) => (
            <TableColumn
              aria-expanded={column.id === ACTIVITY_COLUMNS_ID.Item}
              key={column.id}
              className={`bg-gray-50 text-[14px] font-[400] text-[#505665] sm:aria-expanded:sticky sm:aria-expanded:left-0 sm:aria-expanded:z-[1] ${getColumnClassNameActivity(
                column.id,
              )}`}
            >
              {column.title}
            </TableColumn>
          )}
        </TableHeader>
        <TableBody items={list} isLoading={loading} emptyContent={<NoData className="h-[350px]" />}>
          {(item) => (
            <TableRow key={item.id} className="border-b-1 border-[#F0F2FA] last:border-none">
              {(columnKey) => (
                <TableCell
                  aria-expanded={columnKey === ACTIVITY_COLUMNS_ID.Item}
                  aria-checked={
                    columnKey !== ACTIVITY_COLUMNS_ID.TransactionType &&
                    columnKey !== ACTIVITY_COLUMNS_ID.Type
                  }
                  className="bg-white py-4 aria-checked:min-w-[150px] sm:py-2 sm:aria-expanded:sticky sm:aria-expanded:left-0 sm:aria-expanded:z-[1]"
                >
                  <ActivityCell data={item} columnKey={columnKey} />
                </TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Pagination
        className="mt-5"
        startPage={Number(page)}
        total={totalPage}
        pageSize={PAGE_SIZE}
        queryPrams={[{ value: KeyTabCollection.Activity, key: 'tab' }]}
        queryOptions={{ scroll: false }}
      />
    </div>
  );
};

export default CollectionActivity;
